'use client';
import { blogAll } from '@bells/i18n';
import { baseLocale, type Locale } from '@bells/i18n/runtime';
import { ScrollArea, ScrollBar } from '@bells/ui/components/scroll-area';
import { Tabs, TabsList, TabsTrigger } from '@bells/ui/components/tabs';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useMemo, useState } from 'react';

export const BlogNavigation = ({
  items,
  lng,
}: {
  items: { title: string; path: string }[];
  lng: Locale;
}) => {
  const path = usePathname();

  const [value, setValue] = useState<string | undefined>(
    path.includes('/blog/page/') ? items[0]?.path : path
  );

  useEffect(() => {
    if (path.includes('/blog/page/')) {
      setValue(items[0]?.path);
    } else {
      setValue(path);
    }
  }, [path, items]);

  const homePath = useMemo(() => {
    return lng === baseLocale ? `/blog` : `/${lng}/blog`;
  }, [lng]);

  return (
    <div className='relative h-14 w-full overflow-hidden'>
      <div className='absolute w-full'>
        <ScrollArea className='w-full whitespace-nowrap'>
          <Tabs value={value}>
            <TabsList>
              <TabsTrigger
                data-state={
                  path == homePath || path.startsWith(`${homePath}/page`)
                    ? 'active'
                    : 'inactive'
                }
                value={homePath}
                asChild
              >
                <Link prefetch={false} href={homePath}>
                  {blogAll()}
                </Link>
              </TabsTrigger>

              {items
                .sort((a, b) => a.title.localeCompare(b.title))
                .map((df, index) => {
                  return (
                    <TabsTrigger
                      data-state={
                        path.startsWith(df.path) ? 'active' : 'inactive'
                      }
                      key={'blog-nav-' + index}
                      value={df.path}
                      asChild
                    >
                      <Link prefetch={false} href={df.path}>
                        {df.title}
                      </Link>
                    </TabsTrigger>
                  );
                })}
            </TabsList>
            <ScrollBar orientation='horizontal' />
          </Tabs>
        </ScrollArea>
      </div>
    </div>
  );
};
